// extracted by mini-css-extract-plugin
export default {"container":"ParentComponent_container__D-q8t","contentArea":"ParentComponent_contentArea__h96vL"};